// AUTO-GENERATED by scripts/generate-tokens.mjs — DO NOT EDIT.
// Source of truth: src/theme/design-tokens.generated.json (key: spacingLayout)
//   <- beoflow-design-tokens-sync (Drafted "Beoflow Design System" / foundations/spacingLayout)
// Regenerate: npm run tokens:gen   (no-drift gate: npm run tokens:check)
//
// The .generated suffix means DO NOT HAND-EDIT. These are the Beoflow spacing & layout tokens.
// Mirrors the iOS Beoflow/Theme/ files; values are web-idiomatic (hex/rgba, numeric weights, px).

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
  xxxl: 32,
  xxxxl: 40,
  xxxxxl: 48,
  xxxxxxl: 56,
  xxxxxxxl: 64,
  componentPadding: 12,
  cardPadding: 16,
  elementSpacing: 8,
  gridGap: 20,
  sectionSpacing: 36,
  screenPadding: 36,
  looseSpacing: 44,
  tightSpacing: 4,
} as const;

export const cornerRadius = {
  small: 4,
  medium: 8,
  large: 12,
  xlarge: 16,
  round: 9999,
  button: 8,
  card: 12,
  sheet: 12,
  input: 8,
} as const;

export const opacity = {
  footer: 0.03,
  glass: 0.05,
  interactiveBackground: 0.08,
  interactiveBorder: 0.15,
  disabled: 0.4,
  secondary: 0.6,
  subtle: 0.8,
  overlay: 0.9,
  full: 1,
} as const;

export const layout = {
  buttonHeight: 48,
  inputHeight: 48,
  controlHeight: 36,
  toolbarHeight: 44,
  navigationBarHeight: 44,
  tabBarHeight: 49,
  maxContentWidth: 600,
  compactWidth: 320,
  regularWidth: 375,
  wideWidth: 414,
  borderDefault: 1,
  borderThin: 0.5,
  borderThick: 2,
  inputCornerRadius: 12,
  inputHorizontalPadding: 16,
  inputVerticalPadding: 10,
  inputFontSize: 14,
  cardAccentStripWidth: 8,
  cardBorderWidth: 1,
  cardPadding: 12,
  cardTitleFontSize: 16,
  cardSportLabelFontSize: 8,
  cardDescriptionFontSize: 12,
  iconTiny: 12,
  iconSmall: 16,
  iconMedium: 24,
  iconLarge: 32,
  iconXLarge: 40,
} as const;

export const animation = {
  quick: 0.2,
  normal: 0.3,
  slow: 0.5,
  springResponse: 0.5,
  springDamping: 0.8,
} as const;

export const surfaces = {
  baseCanvas: '#121212',
  elevatedSurface: '#1E1E1E',
  borderWidth: { thin: 0.5, default: 1, thick: 2 },
} as const;
